module.exports = __webpack_public_path__ + "static/media/onsite-security.2c7f678d.jpg";